import { AVAILABLE_COUNTRIES, countriesList } from './../constants/countries'

function getUserCountry() {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone

  const country = countriesList[timezone]

  return country
}

const isUserCountryAvailable = AVAILABLE_COUNTRIES.some(
  (country) => country.code === getUserCountry(),
)

export function getAvailableCountry(country?: string) {
  if (country) {
    return country
  }

  return isUserCountryAvailable ? getUserCountry() : 'MX'
}
